import React, { useState } from "react";
import "./HintsPage.css";
import { FaPlus, FaMinus } from "react-icons/fa";
import { renderStatementWithKaTeX } from "../../../../../Functions/WriteLaTex";


/* function HintsPage() {
  return (
    <div className="hints-container">
      {hintsData.map((item, index) => (
        <HintCard key={index} problem={item} />
      ))}
    </div>
  );
} */

function HintsPage({ problem }) {
  const [expanded, setExpanded] = useState(false);
  const [revealed, setRevealed] = useState(Array(problem.hints.length).fill(false));

  const toggleExpand = () => setExpanded(!expanded);

  const revealHint = (i) => {
    const newState = [...revealed];
    newState[i] = true;
    setRevealed(newState);
  };

  const hideHint = (i) => {
    const newState = [...revealed];
    newState[i] = false;
    setRevealed(newState);
  };

  return (
    <div className="hint-card">
      <div className="problem-header" onClick={toggleExpand}>
        <h3 className="problem-title">{problem.problemTitle}</h3>
        {expanded ? <FaMinus className="toggle-icon" /> : <FaPlus className="toggle-icon" />}
      </div>

      {expanded && (
        <div className="hint-boxes">
            <hr />
          {problem.hints.map((hint, i) => (
            <div key={i} className="hint-item">
              {revealed[i] ? (
                <div className="hint-text">
                                  👉 <div className="hint-content"> {renderStatementWithKaTeX(hint)}</div>

                  <button className="hide-btn" onClick={() => hideHint(i)}>Hide</button>
                </div>
              ) : (
                <button className="hint-locked" onClick={() => revealHint(i)}>
                  Hint {Math.round(((i + 1) / problem.hints.length) * 100)}%
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default HintsPage;
